export default function Loader() {
    return (
        <>
            <div class="loader"></div>
        </>
    )
}